<template>
  <div>
    <div class="flex items-center justify-start gap-[10px] flex-wrap mb-[24px]">
      <div class="flex items-center justify-center bg-[#FFECE9] rounded-full size-[44px]">
        <span class="k-people text-[24px] text-[#F95031]" />
      </div>
      <h2 class="font-medium text-[#000000] mb-0 text-[16px]">
        Rekomendasi Creator (Top 5)
      </h2>
    </div>

    <b-table
      :items="dataFetcher.data"
      :fields="CREATOR_RECOMMENDATION_FIELDS"
      :empty-text="emptyTextLabel"
      responsive
      show-empty
      small
      sticky-header
      class="!mb-0"
      :tbody-tr-class="{'hover:bg-slate-100 transition-colors duration-300 cursor-pointer': dataFetcher.data.length}"
    >
      <template #cell(id)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(name)="{ item }">
        <div class="flex flex-col gap-[10px]">
          <span class="flex items-center gap-[4px]">{{ item.name }}<span class="k-export text-[16px] text-[#08A0F7]" /></span>
          <span class="text-[12px] text-[#828282]">{{ item.email }}</span>
        </div>
      </template>
      <template #cell(phone)="{ value }">
        <span class="flex items-center gap-[4px]">
          {{ value }} <span
            class="k-copy text-[16px] text-[#626262] hover:bg-[#E2E2E2] rounded-[4px] p-[4px]"
            @click="copyPhone($event, value)"
          />
        </span>
      </template>
      <template #cell(status)="{ item }">
        <status-pill :status="item.status" />
      </template>
      <template #cell(category)="{ item: { category } }">
        <category-pill :category="category" />
      </template>
      <template #cell(skala)="{ value }">
        <scala-cell :scala="value" />
      </template>
      <template #empty="{emptyText}">
        <empty-table-card
          :fetcher="dataFetcher"
          :label="emptyText"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import StatusPill from '../campaign-list/StatusPill.vue'
import CategoryPill from '../../creator-management/CategoryPill.vue'
import EmptyTableCard from '../../creator-management/EmptyTableCard.vue'
import { CREATOR_RECOMMENDATION_FIELDS } from '../config'
import ScalaCell from './ScalaCell.vue'

export default {
  components: {
    StatusPill,
    CategoryPill,
    EmptyTableCard,
    ScalaCell,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      CREATOR_RECOMMENDATION_FIELDS,
      dataFetcher: {
        isLoading: true,
        error: undefined,
        data: [],
      },
    }
  },
  computed: {
    emptyTextLabel() {
      if (this.dataFetcher.isLoading) return 'Memuat data...'
      if (this.dataFetcher.error) return 'Terdapat kesalahan saat memuat data'
      return 'Tidak ada data yang ditampilkan.'
    },
  },
  mounted() {
    this.initializeFetcher()
    this.dataFetcher.fetchData({
      reset: true,
      options: {
        MinFollowers: this.form.min_followers,
        MinGMV: this.form.min_gmv,
        ProductCategory: this.form.product_category,
        domicile: this.form.domicile,
      },
    })
  },
  methods: {
    copyPhone(e, phone) {
      e.preventDefault()
      e.stopPropagation()
      navigator.clipboard.writeText(phone)
      this.$toast_success({ message: 'Nomor HP berhasil disalin' })
    },
    initializeFetcher() {
      const fnFetch = ({
        MinFollowers, MinGMV, ProductCategory, domicile,
      }) => this.$http_new.get('/komclass/api/v1/komlabs/campaigns/recommend-creators', {
        params: {
          MinFollowers,
          MinGMV,
          ProductCategory,
          domicile,
        },
        paramsSerializer: params => {
          const searchParams = new URLSearchParams()
          Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              value.forEach(v => searchParams.append(key, v))
            } else if (value !== undefined && value !== null) {
              searchParams.append(key, value)
            }
          })
          return searchParams.toString()
        },
      }).then(res => {
        const { data } = res.data

        return {
          data,
        }
      }).catch(() => {
        if (this.dataFetcher.offset === 0) {
          throw new Error('Gagal memuat data')
        }
        return {
          data: [],
        }
      })

      this.dataFetcher = createPaginatedFetcher(fnFetch, 0, 20)
    },
  },
}
</script>
